const mediaData = [
  {
    title: '国产悬疑剧场：烧脑神作合集',
    desc: '精选近年口碑炸裂的国产悬疑佳作，从《隐秘的角落》到《漫长的季节》，每一部都让你欲罢不能，反转不断，烧脑不停。',
    tag: '悬疑推理',
    count: '28部精选',
    img: 'https://readdy.ai/api/search-image?query=Dark%20moody%20Chinese%20suspense%20thriller%20atmosphere%2C%20rainy%20alley%20at%20night%20with%20warm%20neon%20sign%20reflections%2C%20cinematic%20noir%20lighting%2C%20mysterious%20urban%20scene%2C%20film%20noir%20aesthetic%2C%20deep%20shadows%20and%20highlights%2C%20no%20text%2C%20no%20faces%2C%20artistic%20photography%2C%20elegant%20composition&width=800&height=500&seq=media-card-suspense-01&orientation=landscape',
  },
  {
    title: '古装大剧巡礼：匠心制作精品',
    desc: '汇集国内顶级古装制作，从服化道到剧情演绎，每一帧都是视觉盛宴。《长安十二时辰》《庆余年》等口碑之作一网打尽。',
    tag: '古装巨制',
    count: '35部精选',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20ancient%20palace%20interior%20with%20warm%20lantern%20light%2C%20traditional%20silk%20curtains%2C%20ornate%20wooden%20architecture%2C%20soft%20golden%20atmosphere%2C%20cinematic%20period%20drama%20aesthetic%2C%20rich%20warm%20tones%2C%20no%20text%2C%20no%20faces%2C%20artistic%20photography&width=800&height=500&seq=media-card-costume-02&orientation=landscape',
  },
  {
    title: '现实主义力作：直击社会议题',
    desc: '国产现实题材电影强势崛起，《我不是药神》《八角笼中》《孤注一掷》等作品用电影语言讲述时代故事，引发全民讨论。',
    tag: '现实题材',
    count: '42部精选',
    img: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20street%20scene%20at%20dusk%2C%20warm%20golden%20hour%20light%2C%20everyday%20city%20life%2C%20cinematic%20documentary%20style%2C%20authentic%20atmosphere%2C%20soft%20natural%20lighting%2C%20no%20text%2C%20no%20faces%2C%20artistic%20photography%2C%20humanistic%20composition&width=800&height=500&seq=media-card-realism-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            精彩推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精心策划的专题影单，帮你快速找到想看的国产好片
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {mediaData.map((item) => (
            <div
              key={item.title}
              className="rounded-lg overflow-hidden bg-background-50 cursor-pointer group"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs font-medium bg-background-950/70 text-background-50 px-2 py-1 rounded whitespace-nowrap">
                    {item.count}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/60 px-2 py-0.5 rounded mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}